import AccountsService from "./AccountsService";
import NavSignin from "./NavSignin";

class NavSigninLoader {

	start (opts) {
		var navSignin = new NavSignin();
		navSignin.updatelinks();
		AccountsService.get(function (err, acct) {
			if (err) return console.error(err);

			navSignin.toggleUpdate(acct);
			navSignin.attach(acct);

			acct.onlogout(function () {
				navSignin.toggleUpdate(acct);
			});

			acct.onlogin(function () {
				navSignin.toggleUpdate(acct);
			});
		});
	}

	init () {
		//only start the events if there is global nav; otherwise, it will cause js error
		if ( document.getElementById( "account-nav-container" ) ) {
			this.start();
		}
		else {
			return;
		}
	}
}

export default NavSigninLoader;




// WEBPACK FOOTER //
// ./assets/components/account/NavSigninLoader.js